import React from 'react';

const SectionVisuals = ({ arcColor = '#a259ff', blobColor = '#4f8cff', arcStyle = {}, blobStyle = {} }) => (
  <>
    {/* Iridescent Arc */}
    <svg
      style={{
        position: 'absolute',
        top: arcStyle.top || '10%',
        left: arcStyle.left || 0,
        width: arcStyle.width || '100vw',
        height: arcStyle.height || 120,
        zIndex: 0,
        pointerEvents: 'none',
        ...arcStyle,
      }}
      viewBox="0 0 1440 120"
      fill="none"
    >
      <defs>
        <linearGradient id="arcGrad" x1="0" y1="0" x2="1440" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor={arcColor} />
          <stop offset="1" stopColor={blobColor} />
        </linearGradient>
      </defs>
      <path
        d="M0,100 Q720,20 1440,100"
        stroke="url(#arcGrad)"
        strokeWidth="2.5"
        fill="none"
        opacity="0.13"
        style={{
          filter: 'blur(0.5px)',
          animation: 'arcHue 12s linear infinite alternate',
        }}
      />
    </svg>
    {/* Blurry Blob */}
    <div
      style={{
        position: 'absolute',
        top: blobStyle.top || '40%',
        left: blobStyle.left || '60vw',
        width: blobStyle.size || 220,
        height: blobStyle.size || 220,
        background: `radial-gradient(circle at 60% 40%, ${blobColor}cc 0%, transparent 80%)`, // more saturated
        filter: 'blur(24px)', // less blur for visibility
        opacity: 0.35, // increased opacity for visibility
        borderRadius: '50%',
        zIndex: 0,
        pointerEvents: 'none',
        animation: 'blobDrift 18s ease-in-out infinite alternate',
        ...blobStyle,
      }}
    />
    <style>{`
      @keyframes arcHue {
        0% { filter: hue-rotate(0deg); }
        100% { filter: hue-rotate(40deg); }
      }
      @keyframes blobDrift {
        0% { transform: translateY(0) scale(1); }
        100% { transform: translateY(-24px) scale(1.08); }
      }
    `}</style>
  </>
);

export default SectionVisuals; 